import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('root element missing');
// NOTE: StrictMode is intentionally NOT enabled. In dev it double-invokes
// effects, which cancels our rAF tick loop on the first cleanup before the
// second mount. Production behavior is what we ship anyway.
createRoot(rootEl).render(<App />);
